export const SET_MODE = 'SET_MODE'
export const SET_SELECTED = 'SET_SELECTED'
export const SET_SELECTED_BACKUP = 'SET_SELECTED_BACKUP'